import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { HomeWork } from "@material-ui/icons";
import { RootState } from "config/store";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Production } from "shared/network/production.api";
import { listItemsInWarehousePageableWithWarehouse } from "shared/network/warehouse.api";
import WarhouseSelectDialog from "./WarhouseSelectDialog";
import { COLORS } from "config/theme";

const RelItemCard = ({
  production,
  assemblyItem,
  idx,
  refetch,
  saveProduction,
}: {
  production: Production;
  assemblyItem: any;
  idx: number;
  refetch: () => void;
  saveProduction: () => void;
}) => {
  const { t } = useTranslation();
  const form = useFormContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  const unit =
    assemblyItem?.item?.productUnit === "OWN"
      ? assemblyItem?.item?.customUnitTypeName
      : t(`item.unit.${assemblyItem?.item?.productUnit}`);

  const selectedQuantity = form.watch(`relProductionItems.${idx}.warehouses`);
  const totalSelected = Array.isArray(selectedQuantity)
    ? selectedQuantity.reduce((sum, wh) => sum + (Number(wh?.quantity) || 0), 0)
    : 0;

  return (
    <Box mb={1} p={1} border={1} borderRadius={4} borderColor="#eee">
      <Box fontWeight="bold" fontSize={14} fontFamily="Montserrat" pb={1}>
        {assemblyItem.item?.name}
      </Box>
      <Box display="flex" width="100%">
        <Box flex={1} style={{ fontWeight: "bold" }}>
          Receptúra mennyiség:
        </Box>
        <Box flex={1} textAlign="right">
          {assemblyItem.quantity} {unit}
        </Box>
      </Box>
      {assemblyItem.warehouseAggregate?.quantity ? (
        <Box>
          <Box display="flex" width="100%">
            <Box flex={1} style={{ fontWeight: "bold" }}>
              Összes raktárkészlet:
            </Box>
            <Box flex={1} textAlign="right">
              {assemblyItem.warehouseAggregate?.quantity
                ? assemblyItem.warehouseAggregate?.quantity + " " + unit
                : "Nincs raktáron"}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>Nincs raktáron</Box>
      )}
      <Box>
        <Divider style={{ marginTop: 8, marginBottom: 8 }} />

        <Box display="flex" width="100%">
          <Box flex={1} style={{ fontWeight: "bold", color: !totalSelected ? "red" : undefined }}>
            Felhasználni kívánt mennyiség:
          </Box>
          <Box flex={1} textAlign="right" style={{ color: !totalSelected ? "red" : undefined }}>
            {totalSelected ? (
              <>
                {totalSelected} {unit}
              </>
            ) : (
              "Válassz raktárat!"
            )}
          </Box>
        </Box>
        <Box mt={1} display="flex" justifyContent="center">
          <Button
            variant="outlined"
            size="small"
            startIcon={<HomeWork />}
            onClick={() => setDialogOpen(true)}
            style={{
              color: !totalSelected ? "red" : undefined,
              borderColor: !totalSelected ? "red" : undefined,
            }}
          >
            {"Raktárkészlet kiválasztása"}
          </Button>
        </Box>
        <WarhouseSelectDialog
          production={production}
          assemblyItem={assemblyItem}
          idx={idx}
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          refetch={refetch}
          saveProduction={saveProduction}
        />
      </Box>
    </Box>
  );
};

export default RelItemCard;
